import {
  ChangeEvent,
  HTMLInputTypeAttribute,
  KeyboardEvent,
  MouseEvent,
  ReactElement,
} from 'react';
import { UseFormRegister } from 'react-hook-form';
import { twMerge } from 'tailwind-merge';
import { InputLabel } from '../InputLabel';
import { RemoveAllSelected } from '../Icons';

export interface InputProps {
  className?: string;
  onChange?: (e: ChangeEvent<HTMLInputElement>) => void;
  onKeyUp?: (e: KeyboardEvent<HTMLInputElement>) => void;
  onResetInput: () => void;
  placeHolder?: string;
  type?: HTMLInputTypeAttribute;
  value?: string;
  isDisabled?: boolean;
  name: string;
  register?: UseFormRegister<any>;
  accept?: string;
  step?: string;
  hasError?: boolean;
  errorText?: string;
  label?: string;
  inputLabelClassName?: string;
}

export const Input = ({
  type = 'text',
  className,
  placeHolder,
  value,
  name,
  onChange,
  onResetInput,
  isDisabled,
  register,
  onKeyUp,
  accept,
  step,
  hasError,
  errorText,
  label,
  inputLabelClassName,
}: InputProps): ReactElement => (
  <div className="flex flex-col gap-2">
    {label && (
      <InputLabel
        disabled={isDisabled}
        className={inputLabelClassName}
        label={label}
      />
    )}
    <div className="flex flex-col gap-1">
      <div className="relative w-fit">
        <input
          onKeyUp={onKeyUp}
          onChange={onChange}
          disabled={isDisabled}
          type={type}
          value={value ?? ''}
          accept={accept}
          step={step}
          className={twMerge(
            'h-10 w-60 rounded-[5px] border border-gray-100 bg-gray-100 p-2 pr-8 text-sm font-normal text-gray-400 outline-none',
            'hover:border-blue-500',
            'focus:border-blue-500',
            !value && 'italic',
            value && 'text-gray',
            hasError && 'border-red',
            isDisabled && 'border-none text-gray-300',
            className,
          )}
          placeholder={placeHolder}
          {...(register && { ...register(name) })}
        />
        {value && onResetInput && (
          <div className="absolute right-2 top-1/2 -translate-y-1/2 cursor-pointer">
            <RemoveAllSelected
              className={twMerge('rounded-[3px] bg-gray')}
              onClick={(event: MouseEvent) => {
                event.stopPropagation();
                onResetInput?.();
              }}
            />
          </div>
        )}
      </div>
      {hasError && (
        <span className="text-sm font-normal text-red">{errorText}</span>
      )}
    </div>
  </div>
);
